module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_0.34966494.png";